module.exports = __webpack_public_path__ + "img/chit_tokenizednft.b7ab5e7.png";